<accordion>
  @for (item of depositNotes; track item; let i = $index) {
    <accordion-group class="list-accounts" #accGroup
      [isOpen]="accGroup?.isOpen || isSelectedDepositNote(item)">
      <span accordion-heading>
        <div class="account-items font-13 d-flex align-items-center {{ item.subDepositNotes.length == 0?'last-level':''}}">
          @if (item.subDepositNotes.length !== 0) {
            <button class="btn" type="button" id="{{item.id}}">
              <em class="fa font-25"
                [ngClass]="{'fa-minus-square-o': accGroup?.isOpen, 'fa-plus-square-o': !accGroup?.isOpen}">
              </em>
            </button>
          }
          <span class="account-parent-name mt-10 level-{{level}} font-bold" id="level-{{level}}"
            [ngClass]="{'pl-5': item.subDepositNotes.length === 0}">
            {{item.name}}
          </span>
          <input
            type="checkbox"
            (click)="$event.stopPropagation()"
            (change)="changeNoteStatus(item, $event)"
            class="account-checkbox"
            [disabled]="item.mandatory"
            [checked]="isSelectedDepositNote(item)">
          </div>
        </span>
        @if (item.subDepositNotes.length !== 0) {
          <div>
            <app-deposit-note-node [depositNotes]="item.subDepositNotes"
              [selectedDepositNotes]="selectedDepositNotes"
              (onAddDepositNote)="addDepositNote($event)"
              (onDeleteDepositNote)="deleteDepositNote($event)">
            </app-deposit-note-node>
          </div>
        }
      </accordion-group>
    }
  </accordion>